module.exports = __webpack_public_path__ + "img/UTGREA-5.6b1b19b8.jpg";